import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { Button, FormControlLabel, Radio } from '@material-ui/core';
import { useMutation } from 'react-query';
import { addAlert } from '../../actions/alerts.action';
import { createComment } from '../../api/objective/comment.api';

const useStyles = makeStyles(theme => ({
  sendBtn: {
    marginTop: '20px',
    marginBottom: '20px'
  },
  radio: {
    color: '#9FA2B4'
  },
  labelPublic: {
    marginLeft: '0'
  },
  labelPrivate: {
    [theme.breakpoints.down('xs')]: {
      marginLeft: '0'
    }
  }
}));

const NewComment = ({ objectiveId, onSubmitSuccess }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [ content, setContent ] = useState('');
  const [ isPublic, setIsPublic ] = useState(true);

  const createCommentMutation = useMutation(
    async () => {
      return await createComment({
        objectiveId,
        comment: {
          content,
          objectiveId,
          isPublic
        }
      });
    },
    {
      onSuccess: () => {
        onSubmitSuccess();
        setContent('');
        setIsPublic(true);
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const onContentChange = event => {
    setContent(event.target.value);
  };

  return (
    <>
      <FormControlLabel
        checked={ isPublic }
        onChange={ () => setIsPublic(true) }
        control={
          <Radio classes={ { root: classes.radio } }/>
        }
        label={ t('objective.comment.selectType.public') }
        labelPlacement="start"
        className={ classes.labelPublic }
      />
      <FormControlLabel
        checked={ !isPublic }
        onChange={ () => setIsPublic(false) }
        control={
          <Radio classes={ { root: classes.radio  } }/>
        }
        label={ t('objective.comment.selectType.note') }
        labelPlacement="start"
        className={ classes.labelPrivate }
      />
      <TextField
        value={ content }
        onChange={ onContentChange }
        variant="outlined"
        color="secondary"
        fullWidth
        multiline
        minRows={ 3 }
        maxRows={ 3 }
        placeholder={ isPublic ?
          t('objective.comment.public.create.placeholder') :
          t('objective.comment.note.create.placeholder')
        }
      />
      <Button
        className={ classes.sendBtn }
        onClick={ createCommentMutation.mutate }
        variant="contained"
        color="secondary"
        disabled={ content === '' }
      >
        { isPublic ?
          t('objective.comment.public.create.btn')  :
          t('objective.comment.note.create.btn')
        }
      </Button>
    </>
  );
};

export default NewComment;
